/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ documentType: NonNullable<unknown> }} Document_Type_LabelInputs */

const en_document_type_label = /** @type {(inputs: Document_Type_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.documentType === "claim_notice") return /** @type {LocalizedString} */ (`Claim notice`);
	if (i?.documentType === "police_report") return /** @type {LocalizedString} */ (`Police report / BO`);
	if (i?.documentType === "accident_photos") return /** @type {LocalizedString} */ (`Accident photos/videos`);
	if (i?.documentType === "repair_estimate") return /** @type {LocalizedString} */ (`Repair estimate`);
	if (i?.documentType === "invoice") return /** @type {LocalizedString} */ (`Invoice`);
	if (i?.documentType === "drivers_license") return /** @type {LocalizedString} */ (`Driver's license (CNH)`);
	if (i?.documentType === "vehicle_document") return /** @type {LocalizedString} */ (`Vehicle document (CRLV)`);
	if (i?.documentType === "expert_report") return /** @type {LocalizedString} */ (`Expert report`);
	if (i?.documentType === "other") return /** @type {LocalizedString} */ (`Other document`);
	if (i?.documentType === "post_repair_photos") return /** @type {LocalizedString} */ (`Post-repair photos`);
	if (i?.documentType === "repair_work_order") return /** @type {LocalizedString} */ (`Repair work order (OS)`);
	if (i?.documentType === "repair_invoice") return /** @type {LocalizedString} */ (`Repair invoice`);
	if (i?.documentType === "tow_invoice") return /** @type {LocalizedString} */ (`Tow / car rental invoice`);
	if (i?.documentType === "vehicle_purchase_invoice") return /** @type {LocalizedString} */ (`Vehicle purchase invoice`);
	if (i?.documentType === "warranty_terms") return /** @type {LocalizedString} */ (`Warranty terms`);
	if (i?.documentType === "identity_document") return /** @type {LocalizedString} */ (`ID document (RG / CPF)`);
	if (i?.documentType === "proof_of_address") return /** @type {LocalizedString} */ (`Proof of address`);
	if (i?.documentType === "power_of_attorney") return /** @type {LocalizedString} */ (`Power of attorney`);
	if (i?.documentType === "bank_details") return /** @type {LocalizedString} */ (`Bank / PIX details`);
	if (i?.documentType === "income_proof") return /** @type {LocalizedString} */ (`Proof of income`);
	if (i?.documentType === "payment_receipt") return /** @type {LocalizedString} */ (`Payment receipt`);
	if (i?.documentType === "settlement_agreement") return /** @type {LocalizedString} */ (`Settlement agreement`);
	if (i?.documentType === "debt_confession") return /** @type {LocalizedString} */ (`Debt confession`);
	if (i?.documentType === "insurance_policy") return /** @type {LocalizedString} */ (`Insurance policy`);
	if (i?.documentType === "vehicle_downtime_declaration") return /** @type {LocalizedString} */ (`Workshop vehicle-downtime declaration`);
	if (i?.documentType === "notification_receipt_proof") return /** @type {LocalizedString} */ (`Notification send/receive receipt proof`);
	if (i?.documentType === "dvc") return /** @type {LocalizedString} */ (`DVC`);
	if (i?.documentType === "third_party_contact_record") return /** @type {LocalizedString} */ (`Third-party contact record`);
	if (i?.documentType === "extrajudicial_notice") return /** @type {LocalizedString} */ (`Extrajudicial notice`);
	return /** @type {LocalizedString} */ (`${i?.documentType}`)
	
};

const pt_br2_document_type_label = /** @type {(inputs: Document_Type_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.documentType === "claim_notice") return /** @type {LocalizedString} */ (`Aviso de sinistro`);
	if (i?.documentType === "police_report") return /** @type {LocalizedString} */ (`Boletim de ocorrência / BO`);
	if (i?.documentType === "accident_photos") return /** @type {LocalizedString} */ (`Fotos/vídeos do acidente`);
	if (i?.documentType === "repair_estimate") return /** @type {LocalizedString} */ (`Orçamento de reparo`);
	if (i?.documentType === "invoice") return /** @type {LocalizedString} */ (`Nota fiscal`);
	if (i?.documentType === "drivers_license") return /** @type {LocalizedString} */ (`Carteira de habilitação (CNH)`);
	if (i?.documentType === "vehicle_document") return /** @type {LocalizedString} */ (`Documento do veículo (CRLV)`);
	if (i?.documentType === "expert_report") return /** @type {LocalizedString} */ (`Laudo pericial`);
	if (i?.documentType === "other") return /** @type {LocalizedString} */ (`Outro documento`);
	if (i?.documentType === "post_repair_photos") return /** @type {LocalizedString} */ (`Fotos do veículo reparado`);
	if (i?.documentType === "repair_work_order") return /** @type {LocalizedString} */ (`Ordem de serviço (OS)`);
	if (i?.documentType === "repair_invoice") return /** @type {LocalizedString} */ (`Nota fiscal do reparo`);
	if (i?.documentType === "tow_invoice") return /** @type {LocalizedString} */ (`Nota fiscal de guincho / locação`);
	if (i?.documentType === "vehicle_purchase_invoice") return /** @type {LocalizedString} */ (`Nota fiscal de compra do veículo`);
	if (i?.documentType === "warranty_terms") return /** @type {LocalizedString} */ (`Termo de garantia`);
	if (i?.documentType === "identity_document") return /** @type {LocalizedString} */ (`RG / documento de identidade`);
	if (i?.documentType === "proof_of_address") return /** @type {LocalizedString} */ (`Comprovante de residência`);
	if (i?.documentType === "power_of_attorney") return /** @type {LocalizedString} */ (`Procuração`);
	if (i?.documentType === "bank_details") return /** @type {LocalizedString} */ (`Dados bancários / PIX`);
	if (i?.documentType === "income_proof") return /** @type {LocalizedString} */ (`Comprovante de rendimentos`);
	if (i?.documentType === "payment_receipt") return /** @type {LocalizedString} */ (`Comprovante de pagamento`);
	if (i?.documentType === "settlement_agreement") return /** @type {LocalizedString} */ (`Termo de acordo`);
	if (i?.documentType === "debt_confession") return /** @type {LocalizedString} */ (`Confissão de dívida`);
	if (i?.documentType === "insurance_policy") return /** @type {LocalizedString} */ (`Apólice de seguro`);
	if (i?.documentType === "vehicle_downtime_declaration") return /** @type {LocalizedString} */ (`Declaração da oficina sobre veículo parado`);
	if (i?.documentType === "notification_receipt_proof") return /** @type {LocalizedString} */ (`Comprovante de envio/recebimento de notificação`);
	if (i?.documentType === "dvc") return /** @type {LocalizedString} */ (`DVC`);
	if (i?.documentType === "third_party_contact_record") return /** @type {LocalizedString} */ (`Registro de contatos com terceiro`);
	if (i?.documentType === "extrajudicial_notice") return /** @type {LocalizedString} */ (`Notificação extrajudicial`);
	return /** @type {LocalizedString} */ (`${i?.documentType}`)
	
};

/**
* | documentType | output |
* | --- | --- |
* | "claim_notice" | "Claim notice" |
* | "police_report" | "Police report / BO" |
* | "accident_photos" | "Accident photos/videos" |
* | "repair_estimate" | "Repair estimate" |
* | "invoice" | "Invoice" |
* | "drivers_license" | "Driver's license (CNH)" |
* | "vehicle_document" | "Vehicle document (CRLV)" |
* | "expert_report" | "Expert report" |
* | "other" | "Other document" |
* | "post_repair_photos" | "Post-repair photos" |
* | "repair_work_order" | "Repair work order (OS)" |
* | "repair_invoice" | "Repair invoice" |
* | "tow_invoice" | "Tow / car rental invoice" |
* | "vehicle_purchase_invoice" | "Vehicle purchase invoice" |
* | "warranty_terms" | "Warranty terms" |
* | "identity_document" | "ID document (RG / CPF)" |
* | "proof_of_address" | "Proof of address" |
* | "power_of_attorney" | "Power of attorney" |
* | "bank_details" | "Bank / PIX details" |
* | "income_proof" | "Proof of income" |
* | "payment_receipt" | "Payment receipt" |
* | "settlement_agreement" | "Settlement agreement" |
* | "debt_confession" | "Debt confession" |
* | "insurance_policy" | "Insurance policy" |
* | "vehicle_downtime_declaration" | "Workshop vehicle-downtime declaration" |
* | "notification_receipt_proof" | "Notification send/receive receipt proof" |
* | "dvc" | "DVC" |
* | "third_party_contact_record" | "Third-party contact record" |
* | "extrajudicial_notice" | "Extrajudicial notice" |
* | * | "{documentType}" |
*
* @param {Document_Type_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const document_type_label = /** @type {((inputs: Document_Type_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Document_Type_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_document_type_label(inputs)
	return pt_br2_document_type_label(inputs)
});